import { BaseService } from "./common/base";

export class ChannelService extends BaseService<any> {
  constructor() {
    super("channels");
  }

  createMessage(id, data) {
    return this.api.post(`${id}/message`, data).then((res) => res.data);
  }
}
